var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.844,
    y: 0.5,
    width: 32.115,
    height: 19,
    rx: 1.5,
    fill: "#fff",
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33 20h21.129a4 4 0 004-4v-4.767S24.584 17.289 8.33 20z",
    fill: "#E6772F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "discover_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 11,
    width: 26,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33 20h21.129a4 4 0 004-4v-4.767S24.584 17.289 8.33 20z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 9.94c-.248.215-.565.308-1.07.308h-.21V7.695h.21c.505 0 .81.087 1.07.312a1.301 1.301 0 010 1.934zm-.914-2.9H4.337v3.862H5.48c.608 0 1.046-.139 1.43-.446.458-.364.729-.914.729-1.483 0-1.14-.885-1.932-2.152-1.932zM7.998 7.04h.78v3.862h-.78V7.041zM10.69 8.52c-.47-.165-.607-.276-.607-.485 0-.242.246-.426.583-.426.235 0 .427.09.633.31l.407-.513a1.785 1.785 0 00-1.177-.43c-.71 0-1.25.476-1.25 1.105 0 .534.25.804.985 1.061.306.103.462.173.541.22a.456.456 0 01.234.399c0 .314-.258.545-.608.545a.928.928 0 01-.852-.516l-.505.47c.36.509.793.736 1.388.736.812 0 1.383-.524 1.383-1.27 0-.613-.265-.892-1.154-1.205zM12.091 8.973c0 1.135.926 2.015 2.117 2.015.336 0 .624-.063.978-.225v-.887c-.313.303-.588.423-.944.423-.787 0-1.345-.549-1.345-1.332 0-.74.576-1.325 1.31-1.325.372 0 .655.126.98.434V7.19a2.06 2.06 0 00-.963-.236c-1.185 0-2.133.897-2.133 2.019zM21.52 9.633l-1.068-2.592h-.853L21.3 11h.419l1.732-3.96h-.845L21.52 9.634zM23.805 10.902h2.217v-.654h-1.435V9.206h1.38v-.654h-1.38v-.857h1.435V7.04h-2.217v3.861zM27.55 8.817h-.228V7.648h.24c.489 0 .75.198.75.574 0 .387-.261.595-.763.595zm1.567-.637c0-.723-.515-1.14-1.417-1.14h-1.162v3.862h.784V9.35h.102l1.08 1.553h.962l-1.261-1.628c.59-.116.912-.504.912-1.095z",
    fill: "#02212C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.71 8.982c0 1.112-.936 2.013-2.09 2.013-1.155 0-2.09-.901-2.09-2.013 0-1.112.935-2.013 2.09-2.013 1.154 0 2.09.9 2.09 2.013z",
    fill: "#E6772F"
  })));
};

export default SvgDiscover;